import type { Preview } from "@storybook/react";
import StorybookContainer from "../app/__stories_7__/StorybookContainer";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";

if (process.env.STORYBOOK === undefined) {
    console.log("APOLLO: Loading dev messages");
    loadDevMessages();
    loadErrorMessages();
}

const preview: Preview = {
    parameters: {
        controls: {
            matchers: {
                color: /(background|color)$/i,
                date: /Date$/,
            },
        },
        layout: "fullscreen",
    },

    decorators: [
        (StoryFn) => (
            <StorybookContainer back="background">
                <StoryFn />
            </StorybookContainer>
        ),
    ],
};

export default preview;
